/**
 * @module actions/priceModel
 */
import axios from 'axios'
import {
  API_URL,
  SET_PRICEMODEL_LIST
} from '../constants'

/**
 * @description Getting price lists from the API
 * @return {Promise} Axios promise
 */
export function getPriceLists (CustomerId, workProviderId) {
  let url = API_URL + '/Pricemodel/get?CustomerId=' + CustomerId + '&workProviderId=' + workProviderId
  return dispatch => {
    return axios.get(url).then((res) => {
      dispatch({
        type: SET_PRICEMODEL_LIST,
        pricemodels: res.data
      })
      return res
    })
  }
}

/**
 * @description Getting price list from the API
 * @return {Promise} Axios promise
 */
export function getPriceList (id, customerId = 0) {
  let url = API_URL + '/PriceModel/Get/' + id
  if (customerId !== undefined && customerId > 0) url += '?CustomerId=' + customerId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Updates pricelist
 * @return {Promise} Axios promise
 */
export function updatePriceList (data) {
  let url = API_URL + '/PriceModel/Post'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Reorder items in price lists.
 * @return {Promise} Axios promise
 */
export function reorderPriceListItem (item) {
  let url = API_URL + '/Pricemodel/SortTasks'
  return dispatch => {
    return axios.post(url, item)
  }
}

/**
 * @description Getting the tasks, services and extras using the API
 * @return {Promise} Axios promise
 */
export function getPriceInformations (type, brand, customerId, deviation, IsEstimation, isAddon, orderId, isBodyShop, otherDamage = false) {
  var data = {
    type: type,
    brand: brand,
    customerId: customerId,
    deviation: deviation,
    IsOtherDamage: otherDamage,
    IsEstimation: IsEstimation,
    isAddon: isAddon,
    orderId: orderId,
    isBodyShop: isBodyShop
  }
  return getPriceInformation(data)
}

/**
 * @description Getting the tasks, services and extras using the API
 * @return {Promise} Axios promise
 */
export function getPriceInformation (request) {
  let url = API_URL + '/Pricemodel/Parttasks/'
  return dispatch => {
    return axios.post(url, {
      OrderType: request.type,
      BrandName: request.brand,
      CustomerId: request.customerId,
      Deviation: request.deviation,
      IsOtherDamage: request.IsOtherDamage,
      IsEstimation: request.IsEstimation,
      IsAddon: request.isAddon,
      OrderId: request.orderId,
      IsBodyShop: request.isBodyShop
    })
  }
}

export function getShopCustomerAgreement (id, customerId, companyId) {
  let url = API_URL + '/PriceModel/ShopCustomers/Get/' + id + '?customerId=' + customerId + '&companyId=' + companyId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Creates price list from parent.
 * @return {Promise} Axios promise
 */
export function createPriceListFrom (data) {
  let url = API_URL + '/Pricemodel/Create'
  return dispatch => {
    return axios.post(url, data)
  }
}

/**
 * @description Gets list of pricemodels available to inherit.
 * @return {Promise} Axios promise
 */
export function getPriceListimports (customerId) {
  let url = API_URL + '/Pricemodel/imports?CustomerId=' + customerId
  return dispatch => {
    return axios.get(url)
  }
}

/**
 * @description Get price model log.
 * @return {Promise} Axios promise
 */
export function getPriceModelLog (id, userId, fromTime, toTime) {
  let url = API_URL + '/PriceModel/ChangeLog'
  return dispatch => {
    let data = {
      PriceModelId: id,
      UserId: userId,
      FromTime: fromTime,
      ToTime: toTime
    }
    return axios.post(url, data)
  }
}



// WEBPACK FOOTER //
// ./src/app/actions/priceModel.js